import { WeightUnit } from '../enums/weight-unit';
import { DimensionUnit } from '../enums/dimension-unit';

const defaultPackage = {
  weight: {
    unit: WeightUnit.Ounces,
    value: 0,
  },
  dimensions: {
    length: 0,
    width: 0,
    height: 0,
    unit: DimensionUnit.Inches,
  },
  insuredValue: {
    code: 'USD',
    value: 0,
  },
  packageId: '3-false',
  packageTypeId: '3',
};

export const getDefaultPackage = ({ weightUnit, dimensionsUnit, currencyCode }) => {
  const packageToAdd = {
    packageId: defaultPackage.packageId,
    weight: {
      ...defaultPackage.weight,
    },
    dimensions: {
      ...defaultPackage.dimensions,
    },
    insuredValue: {
      ...defaultPackage.insuredValue,
    },
  };

  if (weightUnit) {
    packageToAdd.weight.unit = weightUnit;
  }

  if (dimensionsUnit) {
    packageToAdd.dimensions.unit = dimensionsUnit;
  }

  if (currencyCode) {
    packageToAdd.insuredValue.code = currencyCode;
  }

  return packageToAdd;
};

export const buildPackageWithPreferredUnits = (actualPack = {}, weightUnit, dimensionsUnit, currencyCode) => {
  const defaultPack = getDefaultPackage({
    weightUnit,
    dimensionsUnit,
    currencyCode,
  });
  const { weight = {}, dimensions = {}, insuredValue = {} } = actualPack;
  return {
    ...defaultPack,
    ...actualPack,
    weight: {
      ...defaultPack.weight,
      ...weight,
    },
    dimensions: {
      ...defaultPack.dimensions,
      ...dimensions,
    },
    insuredValue: {
      ...defaultPack.insuredValue,
      ...insuredValue,
    },
  };
};
